exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\nagm-map{\n  height: 300px !important;\n  width: 100%; \n}\n\n\n", "", {"version":3,"sources":["/home/cubo/pospimus/client/components/address/address.css"],"names":[],"mappings":";AACA;EACE,yBAAyB;EACzB,YAAY;CACb","file":"address.css","sourcesContent":["\nagm-map{\n  height: 300px !important;\n  width: 100%; \n}\n\n\n"],"sourceRoot":""}]);

// exports
